<app-ag-trial-details [params]="rendererParams"></app-ag-trial-details>
